"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var rql_1 = require("../../schemas/rql");
var url_helpers_1 = require("../shared/url_helpers");
var FeedbackShopLink = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackShopLink, _super);
    function FeedbackShopLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeedbackShopLink.prototype.shopUrl = function () {
        var shop = this.props.shop;
        if (this.props.channel === rql_1.core_apimessages_Channel.LP) {
            return url_helpers_1.default.lpShopUrl(shop.slug);
        }
        return url_helpers_1.default.shopPath(shop.slug);
    };
    FeedbackShopLink.prototype.renderShopLink = function () {
        return (React.createElement("a", { className: "shop-icon-link", href: this.shopUrl() }, this.props.shop.name));
    };
    FeedbackShopLink.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("span", { className: "strong" }, I18n.t('discovery.feedbackShopInfo.leavingFeedbackFor')),
            React.createElement("p", { className: "strong" }, this.props.shop ? this.renderShopLink() : this.props.userName)));
    };
    return FeedbackShopLink;
}(React.Component));
exports.default = FeedbackShopLink;
//# sourceMappingURL=feedback_shop_link.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/feedbacks/feedback_shop_link.js
// module id = 6K6m
// module chunks = 20 21